// react
import React from "react";

// react-i18next
import { useTranslation } from "react-i18next";

// @mui
import { Box, Grid, Typography, Divider, CardContent, Stack, useTheme } from "@mui/material";

// A ---------------------------------------------------------------------- M

const Field = ({ label, value }) => (
  <Stack direction="row" spacing={1}>
    <Typography variant="body2" color="text.secondary" fontWeight={600}>
      {label}:
    </Typography>
    <Typography variant="body2">{value ?? "—"}</Typography>
  </Stack>
);

const Section = ({ title, children }) => (
  <Box sx={{ mb: 3 }}>
    <Typography variant="subtitle1" fontWeight={700} color="text.secondary" sx={{ mb: 1 }}>
      {title}
    </Typography>
    <Divider sx={{ mb: 2 }} />
    {children}
  </Box>
);

const ClientDetail = ({ client }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const admin = client.adminUser ?? {};
  const address = client.address ?? {};

  return (
    <Box>
      <CardContent sx={{ p: 0 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Section title={t("company")}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Field label={t("company_name")} value={client.companyName} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Field label={t("vat_number")} value={client.VATNumber} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Field label={t("email")} value={client.email} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Field label={t("phone")} value={client.phone} />
                </Grid>
              </Grid>
            </Section>
          </Grid>

          <Grid item xs={12}>
            <Section title={t("administrator")}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Field label={t("first_name")} value={admin.firstName} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Field label={t("last_name")} value={admin.lastName} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Field label={t("email")} value={admin.email} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Field label={t("phone")} value={admin.phone} />
                </Grid>
              </Grid>
            </Section>
          </Grid>

          <Grid item xs={12}>
            <Section title={t("address")}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Field label={t("street")} value={address.street} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Field label={t("city")} value={address.city} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Field label={t("postal_code")} value={address.postalCode} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Field label={t("country")} value={address.country} />
                </Grid>
              </Grid>
            </Section>
          </Grid>
        </Grid>
      </CardContent>
    </Box>
  );
};

export default ClientDetail;
